import Table from './table';
import TableColumn from './table-column.js';
import Tooltip from '../tooltip/index';
import ZmCheckboxGroup from '../checkbox-group';

export let _Vue;

Table.install = function(Vue) {
  _Vue = Vue;
  Vue.component(Table.name, Table);
  Vue.component(TableColumn.name, TableColumn);
  Vue.use(Tooltip);
  Vue.use(ZmCheckboxGroup);
};

export default Table;
